import { Products, Subtotal, Total } from "../../../../../Constants/Constants";
import { Col } from "reactstrap";
import CheckPayment from "./CheckPayment";
import CheckoutShipping from "./CheckoutShipping";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { getCartTotal, getallCardTotal } from "../../../../../Utils/Ecommerce.service";
import { H4, LI, UL } from "../../../../../AbstractElements";

const ProductCheckout = () => {
  const { cart } = useAppSelector((state) => state.cartData);
  return (
    <Col xl="6" sm="12">
      <div className="checkout-details">
        <div className="order-box">
          <div className="title-box">
            <div className="checkbox-title">
              <H4>{Products} </H4>
              <span>{Total}</span>
            </div>
          </div>
          <UL className="qty simple-list">
            {cart && cart.map((data, i) => (
              <LI key={i}>{data.name} x {data.total} <span>$ {getCartTotal(data)}</span></LI>
            ))}
          </UL>
          <UL className="sub-total simple-list">
            <LI>{Subtotal} <span className="count">$ {getallCardTotal(cart)}</span></LI>
            <CheckoutShipping />
          </UL>
          <UL className="sub-total total simple-list">
            <LI>{Total} <span className="count">$ {getallCardTotal(cart)}</span></LI>
          </UL>
          <CheckPayment />
        </div>
      </div>
    </Col>
  );
};

export default ProductCheckout;
